import React, { useState,useEffect } from "react";
import { FaSave } from "react-icons/fa";
import { AiOutlineDownload } from "react-icons/ai";
import { formatDateForInput } from "../utils/dateFormat"; // adjust path as needed

import TimePicker from "./TimePicker";  // Import the custom TimePicker component
import { format } from "date-fns";     // Import date-fns for time formatting

const BillComponent = ({ registrationForm, setRegistrationForm,saveForm}) => {
    
    const [errors,setErrors]=useState([]);
    
    
       
 const [showModal, setShowModal] = useState(false);
      

  if (!registrationForm) return <p>Loading...</p>;

 
  const handleChange = (e, field, nestedField = null) => {
    let { value } = e.target;
  
    setRegistrationForm((prev) => {
     
     
      if (nestedField) {
        return {
          ...prev,
          [field]: {
            ...prev[field],
            [nestedField]: value,
          },
        };
      }
  
      return {
        ...prev,
        [field]: value,
      };
    });
  };

  
  return (
    <div className="w-full max-w-4xl mx-auto p-1 bg-white shadow-md rounded-md text-sm">
      

      {/* Student Details */}
      <div className="flex flex-col gap-1 ">

        <div className="bg-green-100 p-2">
          <div>
          <label>Name</label>
          <input
            type="text"
            value={registrationForm.name || ""}
            onChange={(e) => handleChange(e, "name")}            
            onBlur={saveForm} 
disabled={registrationForm.submission_status === "submitted"}
  className={`mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}
          />
        </div>
         {/* Phone */}
  <div className="mt-4">
    <label>Phone</label>
    <input
      type="text"
      value={registrationForm.phone || ""}
      onChange={(e) => handleChange(e, "phone")}
      onBlur={saveForm}
      disabled={registrationForm.submission_status === "submitted"}
      className="mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent"
    />
  </div>

  {/* GSTIN */}
  <div className="mt-4">
    <label>GSTIN</label>
    <input
      type="text"
      value={registrationForm.GSTIN || ""}
      onChange={(e) => handleChange(e, "GSTIN")}
      onBlur={saveForm}
      disabled={registrationForm.submission_status === "submitted"}
      className="mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent"
    />
  </div>
      </div>

      <div className="bg-blue-100 p-2 mt-1">
        {/* Address Fields */}
  <div  className="mt-4">
    <label>Village</label>
    <input
      type="text"
      value={registrationForm.address?.village || ""}
      onChange={(e) => handleChange(e, "address", "village")}
      onBlur={saveForm}
      disabled={registrationForm.submission_status === "submitted"}
      className="mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent"
    />
  </div>
  <div className="mt-4">
    <label>Police Station (PS)</label>
    <input
      type="text"
      value={registrationForm.address?.ps || ""}
      onChange={(e) => handleChange(e, "address", "ps")}
      onBlur={saveForm}
      disabled={registrationForm.submission_status === "submitted"}
      className="mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent"
    />
  </div>
  <div className="mt-4">
    <label>P.O.</label>
    <input
      type="text"
      value={registrationForm.address?.mouza || ""}
      onChange={(e) => handleChange(e, "address", "mouza")}
      onBlur={saveForm}
      disabled={registrationForm.submission_status === "submitted"}
      className="mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent"
    />
  </div>
  <div className="mt-4">
    <label>District</label>
    <input
      type="text"
      value={registrationForm.address?.district || ""}
      onChange={(e) => handleChange(e, "address", "district")}
      onBlur={saveForm}
      disabled={registrationForm.submission_status === "submitted"}
      className="mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent"
    />
  </div>
  <div className="mt-4">
    <label>PIN Code</label>
    <input
      type="text"
      value={registrationForm.address?.pin || ""}
      onChange={(e) => handleChange(e, "address", "pin")}
      onBlur={saveForm}
      disabled={registrationForm.submission_status === "submitted"}
      className="mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent"
    />
  </div>
      </div>


<div className="bg-pink-100 p-2 mt-1">
{/* Account Holder */}
<div className="mt-4">
    <label>Account Holder</label>
    <input
      type="text"
      value={registrationForm.account_holder || ""}
      onChange={(e) => handleChange(e, "account_holder")}
      onBlur={saveForm}
      disabled={registrationForm.submission_status === "submitted"}
      className="mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent"
    />
  </div>

  {/* Bank Details */}
  <div className="mt-4">
    <label>Bank Details</label>
    <input
      type="text"
      value={registrationForm.bank_details || ""}
      onChange={(e) => handleChange(e, "bank_details")}
      onBlur={saveForm}
      disabled={registrationForm.submission_status === "submitted"}
      className="mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent"
    />
  </div>

  {/* Account Type */}
  <div className="mt-4">
    <label>Account Type</label>
    <select
      value={registrationForm.account_type || ""}
      onChange={(e) => handleChange(e, "account_type")}
      onBlur={saveForm}
      disabled={registrationForm.submission_status === "submitted"}
      className="mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent"
    >
      <option value="">Select Account Type</option>
      <option value="Savings">Savings</option>
      <option value="Current">Current</option>
    </select>
  </div>

  {/* Account Number */}
  <div className="mt-4">
    <label>Account Number</label>
    <input
      type="text"
      value={registrationForm.account_number || ""}
      onChange={(e) => handleChange(e, "account_number")}
      onBlur={saveForm}
      disabled={registrationForm.submission_status === "submitted"}
      className="mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent"
    />
  </div>

  {/* IFSC */}
  <div className="mt-4">
    <label>IFSC</label>
    <input
      type="text"
      value={registrationForm.ifsc || ""}
      onChange={(e) => handleChange(e, "ifsc")}
      onBlur={saveForm}
      disabled={registrationForm.submission_status === "submitted"}
      className="mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent"
    />
  </div>

</div>



        </div>
      {errors.length > 0 && (
  <div className="bg-gray-100 p-2 rounded-lg shadow-md w-full border border-gray-300 mt-3 flex flex-col">
    {errors.map((error, index) => (
      <p key={index} className="text-red-600 text-sm">
        {error}
      </p>
    ))}
  </div>
)} 
    </div>
  );
};

export default BillComponent;
